import { useEffect } from "react";

const useClickArea = (ref, handlerFn) => {
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (ref?.current?.contains(e?.target)) {
        // console.log("inside");
        return;
      } else {
        // console.log("outside");
        handlerFn();
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [ref, handlerFn]);
  return null;
};

export default useClickArea;
